var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "rs-spoiler",
    style: {
      'min-height': _vm.minHeight
    }
  }, [_c('div', {
    class: {
      disabled: _vm.disabled
    },
    style: {
      background: _vm.background
    },
    on: {
      "click": _vm.handleClick
    }
  }, [_vm._t("header", [_c('div', {
    staticClass: "rs-spoiler-header"
  }, [_c('div', {
    staticClass: "rs-spoiler-header-content"
  }, [_vm._t("title", [_vm._v(_vm._s(_vm.title))])], 2)])], {
    "internalValue": _vm.internalValue
  })], 2), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.internalValue,
      expression: "internalValue"
    }],
    staticClass: "rs-spoiler-content",
    style: {
      background: _vm.background,
      'overflow-y': _vm.fitContent ? 'auto' : 'none'
    }
  }, [_vm.$slots.hasOwnProperty('default') ? _vm._t("default") : _c('div', {
    staticClass: "rs-spoiler-content-default"
  }, [_vm._v(" " + _vm._s(_vm.content) + " ")])], 2)]);
}
var staticRenderFns = []

export { render, staticRenderFns }